import React, { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';
import {
  getNotificationServiceConfig,
  updateNoficationConfig,
} from '../BuzzSlice';
import useToast from '../../../hooks/useToast';
import { Alert } from '@material-ui/lab';

const NotificationServiceConfig = () => {
  const dispatch = useDispatch();
  const { SuccessToast, ErrorToast } = useToast();

  const { notificationConfig } = useSelector((state) => {
    const { buzz } = state;

    return {
      notificationConfig: buzz.notificationConfig,
    };
  });

  useEffect(() => {
    dispatch(getNotificationServiceConfig());
  }, []);

  const handleChange = (key, value) => {
    dispatch(updateNoficationConfig({ key, value }))
      .unwrap()
      .then((res) => {
        SuccessToast('Configuration updated successfully');
        dispatch(getNotificationServiceConfig());
      })
      .catch((err) => {
        ErrorToast('Unable to change the configuration');
      });
  };

  return (
    <Box>
      <p style={{ fontSize: '1.5rem', fontWeight: 500 }}>
        Notification Service Configuration
      </p>

      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid red',
          padding: '0.5rem 1rem',
        }}>
        <p style={{ fontSize: '1.1rem', fontWeight: 500 }}>Drop Brevo Emails</p>
        <Alert severity="info">
          {notificationConfig.dropBrevoEmails === true
            ? 'Brevo template emails will not reach recipients nor will be shown in the logs'
            : 'Brevo template emails will reach recipients and will be visible in logs'}
        </Alert>

        <Box style={{ minWidth: '100px' }}>
          <BuzzSelect
            size="small"
            options={[
              {
                label: `🟢 ${' '} True`,
                value: true,
              },
              {
                label: `🔴 ${' '} False`,
                value: false,
              },
            ]}
            value={notificationConfig.dropBrevoEmails}
            onChange={(e) => {
              handleChange('dropBrevoEmails', e.target.value);
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default NotificationServiceConfig;
